<template>
  <div class="flex flex-wrap gap-12">
    <RefundButton
      v-if="actions.isRefundAllowed"
      :isCustomerBlocked="actions.isCustomerBlocked"
      :isRefundDisabled="actions.isRefundDisabled"
      @click="handleStartRefundFlow"
    />
    <RevButton
      v-if="actions.isShipBackToCustomerAllowed"
      size="small"
      variant="secondary"
      @click="handleStartShipBackFlow"
    >
      {{ i18n(translations.shipBackToCustomer) }}
    </RevButton>

    <RevButton
      v-if="actions.isReportProblemAllowed"
      :disabled="actions.isReportProblemDisabled"
      size="small"
      variant="secondary"
      @click="handleStartReportProblemFlow"
    >
      {{ i18n(translations.reportProblem) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'

import type { ProductReturnState } from '~/api/care-folders/types/care-folder'
import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'
import { ROUTE_NAMES } from '~/constants/routes'
import { useFormatDeadline } from '~/scopes/customer-care/pages/customer-care/composables/useFormatDeadline'

import type { Actions, MachineSend } from '../../../../ActionBar.machine.type'

import translations from './PrimaryActions.translations'
import RefundButton from './components/RefundButton/RefundButton.vue'

const props = defineProps<{
  actions: Actions
  send: MachineSend
  mostUrgentTask?: OrderlineOpenTask
  customerRequestId: number
  productReturnState: ProductReturnState
}>()

const i18n = useI18n()
const tracking = useTracking()

function handleTrackClick(name: string) {
  tracking.trackClick({
    name,
    zone: 'asp-action-bar-action-list-step',
    customerRequestId: props.customerRequestId,
    pageType: ROUTE_NAMES.CUSTOMER_CARE.CUSTOMER_REQUEST,
    mostUrgentDeadline: props.mostUrgentTask
      ? useFormatDeadline(
          props.mostUrgentTask.deadline,
          props.mostUrgentTask.id,
        )
      : '',
    mostUrgentTaskType: props.mostUrgentTask?.status || '',
    productReturnState: props.productReturnState,
  })
}

function handleStartRefundFlow() {
  props.send('START_REFUND_FLOW')
  handleTrackClick('refund')
}

function handleStartShipBackFlow() {
  props.send('START_SHIP_BACK_FLOW')
  handleTrackClick('repair-replace-return')
}

function handleStartReportProblemFlow() {
  props.send('START_REPORT_PROBLEM_FLOW')
  handleTrackClick('report-problem')
}
</script>
